import { toast } from 'react-toastify';

import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';
import { API_SUBSCRIBER_PROFILE_CHANGE_PASSWORD } from '../../../../../constants';

import { setIsWaiting, setShowPopup, setShowRemovePopup } from '../../../../../actions/general';
import { updateProfileUserRequest } from '../actions';

export const SET_ALTERNATE_EMAILS = 'setAlternateEmails';
export const API_SUBSCRIBER_ALTERNATE_EMAILS = 'alternate-email';

export const setAlternateEmails = (alternateEmails) => {
     return {
          type: SET_ALTERNATE_EMAILS,
          payload: alternateEmails,
     };
};
export const fetchSubscriberAlternateEmails = (setAlternateEmailsState, setHasData) => (dispatch, getState) => {
     const alternateEmails = getState().subscriber.alternateEmails;
     const userId = getState().subscriber?.user?.id;

     const data = alternateEmails.filter((data) => !data.isPrimary);
     const newData = [...data];

     newData.map((data) => {
          return (data.userId = userId);
     });

     if (newData.length > 0) {
          setAlternateEmailsState(newData);
          setHasData(true);
     } else {
          setHasData(false);
     }
};

export const fetchSubscriberAlternateEmailsRequest = (setAlternateEmailsState, setHasData) => (dispatch) => {
     callApi(API_SUBSCRIBER_ALTERNATE_EMAILS, 'GET').then((response) => {
          if (response.status === 200) {
               const newData = response.data.filter((data) => !data.isPrimary);
               dispatch(setAlternateEmails(newData));

               if (newData.length > 0) {
                    setAlternateEmailsState(newData);
                    setHasData(true);
               } else {
                    setHasData(false);
               }
          } else {
               toastError(response);
          }
     });
};

export const updateAlternateEmailsRequest =
     (values, newAltEmailsValues, setAlternateEmailsState, setHasData, setSubmitting, setDisableButtonSave) => (dispatch) => {
          callApi(API_SUBSCRIBER_ALTERNATE_EMAILS, 'POST', newAltEmailsValues)
               .then((response) => {
                    setDisableButtonSave(false);
                    if (response.status === 200) {
                         if (response.data.errors) {
                              const listErrors = response.data.errors;
                              const listEmails = newAltEmailsValues.listEmail.filter((data) => !data.isPrimary);
                              const newAlterEmails = listEmails.map((item) => {
                                   const error = listErrors.find((error) => error.email === item.email);
                                   if (error) {
                                        item.error = error.message;
                                   }
                                   return item;
                              });
                              setAlternateEmailsState(newAlterEmails);
                         } else {
                              const newAlterEmails = response.data.filter((data) => !data.isPrimary);
                              dispatch(setAlternateEmails(newAlterEmails));

                              if (newAlterEmails.length) {
                                   setAlternateEmailsState(newAlterEmails);
                                   setHasData(true);
                              } else {
                                   setHasData(false);
                              }
                              dispatch(updateProfileUserRequest(values));
                         }
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    if (setSubmitting) {
                         setSubmitting(false);
                    }
               });
     };

export const proceedRemoveAlternateEmail =
     (
          key,
          alternateEmailsState,
          setAlternateEmailsState,
          setHasData,
          emailId,
          setEmailId,
          setDisableButtonSave,
          valueUser,
          profileUser,
          setIsDeleting
     ) =>
     (dispatch, getState) => {
          const keyItem = getState().general.showRemovePopup;
          const userId = getState().subscriber?.user?.id;
          let newListEmail = [];
          if (emailId !== undefined) {
               dispatch(setIsWaiting(true));
               const emailUser = getState().subscriber?.user?.email;
               const newValues = alternateEmailsState.filter((email) => email.id && email.id !== emailId);
               const newAltEmailsValues = {
                    listEmail: [
                         ...newValues,
                         {
                              userId: userId,
                              email: emailUser,
                              isPrimary: true,
                              status: 'enable',
                         },
                    ],
               };

               setIsDeleting && setIsDeleting(true);

               callApi(API_SUBSCRIBER_ALTERNATE_EMAILS, 'POST', newAltEmailsValues)
                    .then((response) => {
                         setIsDeleting && setIsDeleting(false);

                         if (response.status === 200) {
                              const newAlterEmails = response.data.filter((data) => !data.isPrimary);
                              dispatch(setAlternateEmails(alternateEmailsState.filter((email) => email.id !== emailId)));

                              if (newAlterEmails.length) {
                                   setAlternateEmailsState(alternateEmailsState.filter((email) => email.id !== emailId));
                                   setHasData(true);
                              } else {
                                   setAlternateEmailsState([{}]);
                                   setHasData(false);
                              }
                              setEmailId();
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => {
                         dispatch(setIsWaiting(false));
                    });
          } else {
               let afterRemove = [...alternateEmailsState];
               let newKey = keyItem;

               if (key) {
                    newKey = key;
               }
               afterRemove.splice(newKey, 1);
               newListEmail = afterRemove.map((a) => ({
                    id: a.id,
                    userId,
                    email: a.email,
                    isPrimary: false,
                    status: a.status,
               }));
               setAlternateEmailsState(newListEmail);
          }

          const checkEmpty = newListEmail.filter((item) => item.id === undefined).every((item) => item.email === undefined);

          if (checkEmpty) {
               setDisableButtonSave(true);
          } else {
               setDisableButtonSave(false);
          }

          dispatch(setShowRemovePopup(null));
     };

export const updatePasswordRequest = (values, actionFormik) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SUBSCRIBER_PROFILE_CHANGE_PASSWORD, 'PUT', values)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setShowPopup());
               toast.success('Change password successfully');
          })
          .finally(() => {
               actionFormik.setSubmitting(false);
               dispatch(setIsWaiting(false));
          });
};
